import React from 'react';

// Grain bin outline for the Active Bin tile: vent cap, coned roof with its
// seams, corrugated cylinder and the side ladder. Strokes use currentColor so
// the tile's colour carries the whole drawing, the same way the other icons on
// that panel behave.
const GrainBinIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.9 2.3 H13.1 V3.9 H10.9 Z" />
    <path d="M12 3.9 L4.4 9.3 M12 3.9 L19.6 9.3" />
    <path d="M12 3.9 L8.5 9.3 M12 3.9 L15.5 9.3" />
    <ellipse cx="12" cy="9.3" rx="7.6" ry="1.9" />
    <path d="M4.4 9.3 V18.7 M19.6 9.3 V18.7" />
    <path d="M4.4 12.4 A7.6 1.9 0 0 0 19.6 12.4" />
    <path d="M4.4 15.5 A7.6 1.9 0 0 0 19.6 15.5" />
    <path d="M4.4 18.7 A7.6 1.9 0 0 0 19.6 18.7" />
    <path d="M15.6 13.6 V19.5 M17.3 13.2 V19.2" />
    <path d="M15.6 15.4 H17.3 M15.6 17 H17.3" />
  </svg>
);

export default GrainBinIcon;
